/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const CART_STATE_CONFIGURED_STORAGE_KEY = "CART_STATE_CONFIGURED_STORAGE_KEY";

  /**
   * Renewal checkout gate: when a stylist has a Kit (renewal) product in her
   * cart, show a non-dismissable modal forcing her to either complete checkout
   * or clear the cart entirely (line items + cart attributes + cart note).
   */
  function showKitCheckoutModal() {
    const modal = document.getElementById('kit-checkout-modal');
    if (!modal || !window.MicroModal) return;

    window.MicroModal.show('kit-checkout-modal', {
      disableScroll: true,
      disableFocus: false,
      awaitCloseAnimation: false,
      onClose: function () {
        setTimeout(function () {
          window.MicroModal.show('kit-checkout-modal', { disableScroll: true });
        }, 0);
      },
    });
  }

  async function clearKitCart() {
    const cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

    const cart = await fetch(`${cartUrl}.js?t=${Date.now()}`).then((res) => res.json());

    const attributes = {};
    if (cart.attributes) {
      Object.keys(cart.attributes).forEach((key) => { attributes[key] = ''; });
    }

    const updates = {};
    (cart.items || []).forEach((item) => { updates[item.key] = 0; });

    await fetch(`${cartUrl}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, attributes, note: '' }),
    });
  }

  function initKitCheckoutGate() {
    if (!window.cartHasKit) return;

    const modal = document.getElementById('kit-checkout-modal');
    if (!modal) return;

    const checkoutBtn = modal.querySelector('[data-kit-checkout]');
    const clearBtn = modal.querySelector('[data-kit-clear]');

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        checkoutBtn.disabled = true;
        if (clearBtn) clearBtn.disabled = true;
        if (typeof window.customCheckout === 'function') {
          window.customCheckout();
        } else {
          window.location.href = '/checkout';
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', async function () {
        clearBtn.disabled = true;
        if (checkoutBtn) checkoutBtn.disabled = true;
        try {
          await clearKitCart();
        } catch (err) {
          console.error('Failed to clear renewal cart:', err);
        }
        window.location.reload();
      });
    }

    showKitCheckoutModal();
  }

  document.addEventListener('DOMContentLoaded', initKitCheckoutGate);

  // Function to format date to "Month DD, YYYY"
  // Parses date string directly to avoid timezone issues
  function formatPromisedByDate(dateString) {
    if (!dateString) {
      return null;
    }

    // Extract date part (YYYY-MM-DD) - works for both "2026-01-25" and "2026-01-25T00:00:00Z"
    const datePart = dateString.slice(0, 10);
    const [year, month, day] = datePart.split('-').map(Number);

    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return null;
    }

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthNames[month - 1]} ${day}, ${year}`;
  }

  document.addEventListener("theme:variant:change", async function (event) {
    const { variant } = event.detail;
    const submitBtns = document.querySelector(".product__submit__buttons");
    const formWrapper = submitBtns.closest('product-form');
    const backorderedProp = submitBtns.querySelector("input[name='properties[_backordered]']");
    const promisedByProp = submitBtns.querySelector("input[name='properties[_promised_by]']");
    const promisedByDisplay = submitBtns.querySelector(".product__submit__promised_by");
    const saleProp = submitBtns.querySelector("input[name='properties[_sale]']");

    Promise.all([
      backorderedProp && backorderedProp.remove(),
      promisedByProp && promisedByProp.remove(),
      promisedByDisplay && promisedByDisplay.classList.remove("is-visible"),
      saleProp && saleProp.remove(),
    ]);

    if (variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const saleInput = document.createElement("input");
        saleInput.type = "hidden";
        saleInput.name = "properties[_sale]";
        saleInput.value = "true";
        submitBtns.appendChild(saleInput);
      }

      const inventoryData = await window.backend.getInventoryPromisedBy(variant.id);

      if (inventoryData && inventoryData.is_backordered && inventoryData.promised_by) {
        const promisedByDate = inventoryData.promised_by;
        const formattedDate = formatPromisedByDate(promisedByDate);

        const boInput = document.createElement("input");
        boInput.type = "hidden";
        boInput.name = "properties[_backordered]";
        boInput.value = "true";
        submitBtns.appendChild(boInput);

        const pbInput = document.createElement("input");
        pbInput.type = "hidden";
        pbInput.name = "properties[_promised_by]";
        pbInput.value = promisedByDate;
        submitBtns.appendChild(pbInput);

        promisedByDisplay.classList.add("is-visible");
        const pbEl = promisedByDisplay.querySelector("[data-promised-by]");
        const pbText = pbEl.dataset.promisedBy;
        pbEl.textContent = pbText.replace('[DATE]', formattedDate || promisedByDate.split("T")[0]);
      }
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
      const storedCartStateConfigured = sessionStorage.getItem(CART_STATE_CONFIGURED_STORAGE_KEY);
      if (storedCartStateConfigured) sessionStorage.removeItem(CART_STATE_CONFIGURED_STORAGE_KEY);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:up", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  async function configureCartState() {
    try {
      const storedCartStateConfigured = sessionStorage.getItem(CART_STATE_CONFIGURED_STORAGE_KEY);
      if (storedCartStateConfigured) return;

      const cart = await fetch(`${window.theme.routes.cart}.js?t=${Date.now()}`).then((res) => res.json());
      const foundEnrollmentItems = cart.items.filter((item) => item.properties?._set === "enrollment");

      if (foundEnrollmentItems.length) {
        let data = {};
        data = foundEnrollmentItems.reduce((obj, item) => {
          obj[item.key] = 0;
          return obj;
        }, {});
        await removeFromCart(data);
      }
      sessionStorage.setItem(CART_STATE_CONFIGURED_STORAGE_KEY, Date.now());
    } catch (e) {
      console.warn(e);
    }
  }

  async function removeFromCart(data) {
    return window
      .fetch(`${window.theme.routes.cart}/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: data }),
      })
      .then((res) => res.json())
      .then((res) => {
        if (!res.items) {
          throw new Error("There was a problem updating the cart.");
        }
        document.dispatchEvent(
          new CustomEvent("theme:cart:init", {
            bubbles: true,
          })
        );
      })
      .catch((err) => {
        console.error(err);
      });
  }

  document.addEventListener("DOMContentLoaded", configureCartState);

  // Partner display handler
  document.addEventListener("theme:partner:render", function (event) {
    const partner = event.detail?.partner;

    // Update elements with data-showon-partner attribute
    document.querySelectorAll("[data-showon-partner]").forEach((el) => {
      if (partner) {
        el.classList.remove("d-none");
      } else {
        el.classList.add("d-none");
      }
    });

    // Update elements with data-hideon-partner attribute
    document.querySelectorAll("[data-hideon-partner]").forEach((el) => {
      if (partner) {
        el.classList.add("d-none");
      } else {
        el.classList.remove("d-none");
      }
    });

    // Update partner name in elements with data-partner-name attribute
    if (partner) {
      document.querySelectorAll("[data-partner-name]").forEach((el) => {
        // Use partner.name first, fallback to siteName
        const showHostessName = localStorage.getItem("CURRENT_SHOW_HOSTESS_NAME");
        if (showHostessName) {
          document.querySelectorAll("[data-partner-show-extra]").forEach((el) => {
            if (showHostessName) {
              el.classList.remove("d-none");
            } else {
              el.classList.add("d-none");
            }
          });
        }
        const partnerName = showHostessName || partner.firstName || partner.siteName || "";
        el.textContent = partnerName.trim();
      });
    }

    // Handle show mode UI changes
    const isShoppingUnderShow = !!localStorage.getItem("CURRENT_SHOW_ID");

    // Update role label (Your Stylist vs Your Hostess)
    document.querySelectorAll("[data-partner-role-label]").forEach((el) => {
      if (isShoppingUnderShow) {
        el.textContent = el.dataset.hostessText || "Your Hostess";
      } else {
        el.textContent = el.dataset.stylistText || "Your Stylist";
      }
    });

    // Hide/show elements based on show mode
    document.querySelectorAll("[data-hideon-show]").forEach((el) => {
      if (isShoppingUnderShow) {
        el.style.display = "none";
      } else {
        el.style.display = "";
      }
    });

    // Add show-mode class to partner modal for layout adjustments
    const partnerModal = document.querySelector(".partner-modal__container");
    if (partnerModal) {
      if (isShoppingUnderShow) {
        partnerModal.classList.add("partner-modal--show-mode");
      } else {
        partnerModal.classList.remove("partner-modal--show-mode");
      }
    }
  });

  // Remove consultant handler
  document.addEventListener("DOMContentLoaded", function() {
    const removeConsultantLink = document.querySelector('[data-remove-consultant]');
    
    if (removeConsultantLink) {
      removeConsultantLink.addEventListener('click', function(e) {
        e.preventDefault();
        
        window.closeModalManually('info-partner');
        
        // Clear attribution data from localStorage
        localStorage.removeItem('CURRENT_SITE');
        localStorage.removeItem('CURRENT_SHOW_ID');
        localStorage.removeItem('CURRENT_SHOW_SITE');
        localStorage.removeItem('CURRENT_SHOW_NAME');
        localStorage.removeItem('CURRENT_SHOW_HOSTESS_NAME');
        localStorage.removeItem('CURRENT_STYLIST_ID');

        // Clear attribution data from sessionStorage
        sessionStorage.removeItem('PREFERRED_SITE');
        
        // Clear URL parameters
        const url = new URL(window.location);
        url.searchParams.delete('pws');
        url.searchParams.delete('show');
        window.history.replaceState({}, '', url.toString());
        
        // Clear the global partner object
        window.partner = null;
        
        // Dispatch event to update UI
        document.dispatchEvent(new CustomEvent('theme:partner:render', { 
          detail: { partner: null } 
        }));
        
        console.log('Consultant removed and attribution cleared');
      });
    }
  });

  // Intercept checkout button clicks to use custom checkout
  function interceptCheckoutSubmission() {
    // Track checkout button clicks via click listener for broad browser compatibility
    // (e.submitter is not supported in Safari < 15.4)
    let checkoutClicked = false;

    document.addEventListener("click", function (e) {
      const btn = e.target.closest('[name="checkout"], button[name="checkout"]');
      checkoutClicked = !!btn;
    }, true);

    document.addEventListener("submit", function (e) {
      // Check if this is a cart form
      const form = e.target;
      if (!form.matches('[data-cart-form], form[action*="/cart"]')) return;

      // Check if the checkout button was the trigger
      // Use e.submitter when available, fall back to click flag
      const isCheckout = (e.submitter && e.submitter.name === "checkout") || checkoutClicked;
      checkoutClicked = false;

      if (!isCheckout) return;

      // Prevent default checkout flow
      e.preventDefault();

      // Use custom checkout with context injection
      if (typeof window.customCheckout === "function") {
        console.log("Using custom checkout with context injection");
        window.customCheckout();
      } else {
        console.error("window.customCheckout is not defined");
        // Fallback to normal submission if needed
        form.submit();
      }
    });
  }

  // Initialize checkout interception on DOM ready
  document.addEventListener("DOMContentLoaded", interceptCheckoutSubmission);

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
